export default IconXboxY => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-xbox-y" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z" />
  <path d="M9 8l3 4" />
  <path d="M15 8l-2.988 3.984l-.012 4.016" />
</svg>`;